import { createContext, useContext, useState } from 'react';

const DrawerContext = createContext();

export function DrawerContextProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const toggleDrawer = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <DrawerContext.Provider
      value={{
        isOpen,
        toggleDrawer,
      }}
    >
      {children}
    </DrawerContext.Provider>
  );
}

export function useDrawerContext() {
  return useContext(DrawerContext);
}
